import { Component, forwardRef, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig, ValidationRuleType } from '../../../dynamic-component';

@Component({
  selector: 'app-d-con-number-float',
  templateUrl: './d-con-number-float.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DConNumberFloatComponent),
      multi: true
    }
  ]
})
export class DConNumberFloatComponent extends DynamicComponentBase {
  static KEY = 'd-con-number-float';

  // @HostBinding('style.float') float = 'left';

  ruleType = ValidationRuleType;

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    if (typeof config.step !== 'number') {
      config.step = 1;
    }
    if (!config.effective) {
      config.effective = [];
    }
  }
}
